module.exports = __webpack_public_path__ + "img/l_bg.b4766c7f.png";